"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonContentType = exports.ContentTypeEnum = void 0;
/** Типы контента */
var ContentTypeEnum;
(function (ContentTypeEnum) {
  // /**
  //  * Урок
  //  * @deprecated скоро будет удалено, не используйте!
  //  * @see exercise
  //  */
  // lesson = 1,
  /** Теория */
  ContentTypeEnum[ContentTypeEnum["theory"] = 2] = "theory";
  /** Упражнение */
  ContentTypeEnum[ContentTypeEnum["exercise"] = 3] = "exercise";
  // /**
  //  * Тест
  //  * @deprecated скоро будет удалено, не используйте!
  //  */
  // test = 4,
  /**
   * Словарный запас (Меморайзер) / Словарь
   */
  ContentTypeEnum[ContentTypeEnum["vocabulary"] = 5] = "vocabulary";
  /** Видео */
  ContentTypeEnum[ContentTypeEnum["video"] = 6] = "video";
  /** Статья */
  ContentTypeEnum[ContentTypeEnum["article"] = 7] = "article";
  /** Аудио */
  ContentTypeEnum[ContentTypeEnum["audio"] = 8] = "audio";
  /** Галерея (Картинка) */
  ContentTypeEnum[ContentTypeEnum["image"] = 9] = "image";
  // /**
  //  * Документ
  //  * @deprecated скоро будет удалено, не используйте!
  //  */
  // document = 10,
  /** Новость */
  ContentTypeEnum[ContentTypeEnum["news"] = 11] = "news";
  // /**
  //  * Смешанный контент
  //  * @deprecated скоро будет удалено, не используйте!
  //  */
  // mix = 12,
  // /**
  //  * Словарный запас (Меморайзер)
  //  * @deprecated скоро будет удалено, не используйте!
  //  */
  // memorizer = 13,
  /** Видеоупражнения (Видео-урок) */
  ContentTypeEnum[ContentTypeEnum["video_lesson"] = 14] = "video_lesson";
  /** Аудиоупражнения (Аудио-урок) */
  ContentTypeEnum[ContentTypeEnum["audio_lesson"] = 15] = "audio_lesson";
  /** Чтение (Урок Чтение) */
  ContentTypeEnum[ContentTypeEnum["reading_lesson"] = 16] = "reading_lesson";
  /**
   * Быстрый пост
   */
  ContentTypeEnum[ContentTypeEnum["microtext"] = 17] = "microtext";
  /** Теория с упражнениями */
  ContentTypeEnum[ContentTypeEnum["theory_exercise"] = 18] = "theory_exercise";
  /** Чтение (без упражнений) */
  ContentTypeEnum[ContentTypeEnum["reading"] = 19] = "reading";
})(ContentTypeEnum = exports.ContentTypeEnum || (exports.ContentTypeEnum = {}));
exports.LessonContentType = [ContentTypeEnum.theory, ContentTypeEnum.article, ContentTypeEnum.news, ContentTypeEnum.audio, ContentTypeEnum.video, ContentTypeEnum.image,
// ContentTypeEnum.test,
// ContentTypeEnum.lesson,
ContentTypeEnum.exercise, ContentTypeEnum.video_lesson, ContentTypeEnum.audio_lesson, ContentTypeEnum.reading_lesson, ContentTypeEnum.theory_exercise, ContentTypeEnum.reading];
